import React from 'react';
import cn from 'classnames';

import css from './style.module.scss';

export type TypeGradient =
  | 'green'
  | 'gray'
  | 'azure'
  | 'blue'
  | 'yellow'
  | 'purple'
  | 'red';

interface props {
  type?: TypeGradient;
  className?: string;
}

const RadialCircleGradient: React.FC<props> = ({ type, className }) => {
  return <div className={cn(css.gradient, css[type || ''], className)}></div>;
};

export default RadialCircleGradient;
